export const data = {
    "exp": [
        0,
        450,
        500,
        550,
        610,
        670,
        720,
        780,
        840,
        900,
        960,
        1020,
        1070,
        1130,
        1190,
        1250,
        1310,
        1370,
        1430,
        1500,
        1600,
        1710,
        1830,
        1950,
        2080,
        2210,
        2350,
        2480,
        2620,
        2750,
        2850,
        2960,
        3080,
        3200,
        3330,
        3460,
        3600,
        3730,
        3870,
        4000,
        4140,
        4280,
        4430,
        4570,
        4710,
        4860,
        5000,
        5150,
        5300,
        5440,
        5700,
        6150,
        6630,
        7130,
        7640,
        8170,
        8700,
        9230,
        9780,
        10330,
        20300,
        21780,
        23350,
        24970,
        26630,
        65070,
        68810,
        72490,
        76120,
        79710
    ],
    "daily": [
        200,
        230,
        260,
        290,
        320,
        350,
        380
    ]
}